import { useEffect } from 'react'

/**
 * Injects a third-party script tag once per page.
 * Used for external widgets (callback, call tracking, chat, analytics) that ship
 * as a hosted script rather than an npm package. The tag is intentionally never
 * removed: these widgets can't be "unloaded", and re-injecting them (e.g. on a
 * StrictMode double-mount) would initialize them twice.
 */
export function useExternalScript(src: string): void {
  useEffect(() => {
    if (typeof document === 'undefined') return
    if (document.querySelector(`script[src="${src}"]`)) return

    const script = document.createElement('script')
    script.src = src
    script.async = true
    script.charset = 'utf-8'
    document.head.appendChild(script)
  }, [src])
}
